export const MEDIA = Object.freeze({
  sm: '@media (min-width: 640px) ',
  md: '@media (min-width: 768px) ',
  lg: '@media (min-width: 1024px) ',
  xl: '@media (min-width: 1280px) ',
  desktop: '@media (min-width: 1920px) ',
});

export function deprecatedClassnames(...args: Array<string | undefined>) {
  return args.filter(Boolean).join(' ');
}

export function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {};
}

export const withAlpha = (hexColor, alpha = 1.0) => {
  const { r, g, b } = hexToRgb(hexColor);
  return `rgba(${r}, ${g},${b}, ${alpha})`;
};
